module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-toggle-left-35ae804e.svg";